import * as React from 'react'

import { Box, Tab, Tabs, Tooltip, Typography } from '@mui/material'
import Show from './show'

type Props = {
  items: JSX.Element[]
  tabs: { label: string; index: number; disabled?: boolean; tooltip?: string }[]
  isLoading?: boolean
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  )
}

const CustomTabs = ({ tabs, items, isLoading }: Props) => {
  const [value, setValue] = React.useState(0)
  return (
    <Box sx={{ mx: 3 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={(e, newValue) => setValue(newValue)}>
          {tabs.map((tab, i) => (
            <Tooltip key={tab.label} title={tab.tooltip ?? ''} arrow>
              <Tab
                sx={{ marginLeft: i > 0 ? '3rem !important' : '' }}
                disabled={isLoading || tab.disabled}
                label={tab.label}
                {...a11yProps(tab.index)}
              />
            </Tooltip>
          ))}
        </Tabs>
      </Box>
      {items.map((item, index) => {
        return (
          <TabPanel key={index} value={value} index={index}>
            <Show when={!isLoading}>{item}</Show>
          </TabPanel>
        )
      })}
    </Box>
  )
}

export default CustomTabs
